import { COUNTRY } from '@/app/utils/constant';

export function useCountry() {
  return {
    isCN: COUNTRY === 'cn',
    isKR: COUNTRY === 'kr',
  };
}
